import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Skeleton } from "../components/ui/skeleton";
import { format } from "date-fns";

export default function BlogListPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Blog — YoursDreamDecoration";
    window.scrollTo(0, 0);
    api.get("/blogs")
      .then(res => setBlogs(res.data || []))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50/50 pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4">
        
        <div className="text-center max-w-2xl mx-auto mb-16 space-y-4">
          <h1 className="font-serif-display text-4xl md:text-5xl text-slate-900">
            Our <span className="text-primary italic">Blog</span>
          </h1>
          <p className="text-slate-500 text-lg">
            Tips, ideas, and inspiration for your next big celebration!
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map(i => (
              <div key={i} className="space-y-4">
                <Skeleton className="w-full aspect-video rounded-3xl" />
                <Skeleton className="w-3/4 h-6" />
                <Skeleton className="w-full h-4" />
                <Skeleton className="w-full h-4" />
              </div>
            ))}
          </div>
        ) : blogs.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map(blog => (
              <Link to={`/blog/${blog.slug}`} key={blog.id} className="group flex flex-col bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
                <div className="aspect-video bg-slate-100 overflow-hidden relative">
                  {blog.image ? (
                    <img 
                      src={blog.image} 
                      alt={blog.title} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full bg-primary/10 flex items-center justify-center">
                      <span className="text-primary font-serif-display text-2xl opacity-50">YDD</span>
                    </div>
                  )}
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="text-xs text-slate-400 font-bold uppercase tracking-widest mb-3">
                    {format(new Date(blog.created_at), "MMM dd, yyyy")}
                  </div>
                  <h3 className="text-xl font-serif-display text-slate-900 mb-3 group-hover:text-primary transition-colors line-clamp-2">
                    {blog.title}
                  </h3>
                  <p className="text-slate-500 line-clamp-3 text-sm flex-1">
                    {blog.seo_description || "Read our latest insights and ideas for decoration planning."}
                  </p>
                  <div className="mt-6 text-primary text-sm font-bold uppercase tracking-widest group-hover:translate-x-2 transition-transform inline-flex items-center gap-2">
                    Read More <span>→</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto text-slate-300 mb-4">
              📝
            </div>
            <h3 className="text-xl font-serif-display text-slate-900">No posts yet</h3>
            <p className="text-slate-500">Check back later for amazing decoration ideas!</p>
          </div>
        )}

      </div>
    </div>
  );
}
